import { buildFilterBody } from 'yesObject/shared/api/buildFilterBody'
import fetchYesObjects from 'yesObject/shared/api/fetchYesObjects'

type FetchSitemodelProps = {
  sitemodelUuidOrSid: string
  showLoading?: boolean
  signal?: AbortSignal
}

export const fetchSitemodel = async ({
  sitemodelUuidOrSid,
  showLoading,
  signal
}: FetchSitemodelProps) => {
  const isUuid = sitemodelUuidOrSid.includes('-')

  const filterBody = buildFilterBody({
    objectUUID: isUuid ? sitemodelUuidOrSid : '',
    objectSID: isUuid ? '' : sitemodelUuidOrSid,
    objectclassUUID: globalThis.idObjectclassSitemodel,
    hasActiveSituation: true,
    pagination: { limit: 1, offset: 0 }
  })

  const data = await fetchYesObjects({
    filterBody,
    showLoading,
    signal
  })

  if (data.objects && data.objects.length) {
    return data.objects[0]
  }

  throw new Error('No result')
}
